import React from 'react';
import { Button, Glyphicon, Grid, Row, Col } from 'react-bootstrap';
import FieldGroup from '../../../components/FieldGroup';

export const LoginForm = ({
    credentials,
    errors,
    handleChange,
    submitForm,
    isTAASFetching,
    sessionExpired,
    noAccess,
    environment,
}) => (
    <Grid>
        <Row>
            <Col xs={6} xsOffset={3}>
                <form onSubmit={submitForm} autoComplete="on">
                    <h1 className="text-center">Welcome to FTS</h1>

                    <FieldGroup
                        id="username"
                        name="username"
                        type="text"
                        maxLength="1000"
                        label="Username"
                        placeholder="Enter TME username"
                        value={credentials.username}
                        errorMessage={errors.username}
                        onChange={handleChange}
                    />

                    <FieldGroup
                        id="password"
                        name="password"
                        type="password"
                        label="Password"
                        placeholder="Enter password"
                        value={credentials.password}
                        errorMessage={errors.password}
                        onChange={handleChange}
                    />

                    <Button type="submit" disabled={isTAASFetching || !environment}>
                        <Glyphicon glyph="log-in" />&nbsp;
                        {isTAASFetching ? <em>Logging in...</em> : 'Log in'}
                    </Button>

                    <Button type="button" href='https://idm.toyota-europe.com/siteminderagent/forms/TARSPasswordRules.pdf' target="_blank" rel="noopener noreferrer">
                    <Glyphicon glyph="question-sign" />
                    Forgotten Password ?
                    </Button>
                    
                </form>
            </Col>
        </Row>
    </Grid>
);
